export const version = "sha2/5.5.0";
//# sourceMappingURL=_version.js.map